module.exports = __webpack_public_path__ + "static/media/view games.09feb2da.svg";